import { render } from "./RestoreDialog.vue?vue&type=template&id=10ae0212&scoped=true"
import script from "./RestoreDialog.vue?vue&type=script&lang=js"
export * from "./RestoreDialog.vue?vue&type=script&lang=js"

import "./RestoreDialog.vue?vue&type=style&index=0&id=10ae0212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ae0212"]])

export default __exports__